import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * POST `/crm/customer-order/{id}/close`。
 * body：`updatedAt`；可選 `closeReason`。
 * （`acknowledgeExtraItemShortage` 後端相容欄；前端不送／不影響結果。）
 */
export async function closeCustomerOrder(id, payload = {}) {
  const { data: raw } = await request.post(
    `/crm/customer-order/${id}/close`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
